import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Path, Tree } from '@s8l/client-tree-lib';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CmsService } from 'src/app/services/cms.service';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { MediaModalComponent } from '../../../components/media-modal/media-modal.component';

@Component({
  selector: 'configuration-menu-hero-slider',
  templateUrl: './menu-hero-slider.component.html',
  styleUrls: ['./menu-hero-slider.component.scss']
})
export class MenuHeroSliderComponent implements OnInit, OnDestroy {
  @Input() public rule: any = {};
  @Output() public updateSlides: EventEmitter<any> = new EventEmitter();

  public slides = [];
  public tree: Tree;
  public root: any = {};
  public path: Path;

  private routeSubscription: Subscription = null;
  private expression =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  private regex = new RegExp(this.expression);

  constructor(private imageCache: ImageCacheService, private modal: NgbModal, private cms: CmsService) {}

  public async ngOnInit() {
    if (this.rule?.menuFeatures?.slides) {
      for (const [i, rule] of this.rule.menuFeatures.slides.entries()) {
        this.slides.push({
          ...rule,
          imageUrl: null,
          newHeadline: rule.headline,
          newText: rule.text,
          newLink: rule.link,
          externalLink: rule.externalLink
        });
        await this.heroSlides(i, this.slides[i].image);
      }
    }

    this.routeSubscription = this.cms.tree.pipe(filter(root => root != null)).subscribe(tree => {
      this.tree = tree;
      this.root = tree.root;
      if (!this.path) {
        this.path = new Path([this.root.name]);
      }
    });
  }

  public ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  public addNewSlide() {
    const newSlide = {
      headline: '',
      text: '',
      image: '',
      link: '',
      externalLink: false,
      linkError: '',
      imageUrl: null,
      imageAnchor: 'center',
      newHeadline: '',
      newText: '',
      newLink: ''
    };

    this.slides.push(newSlide);
    this.updateSlides.emit(this.slides);
  }

  public heroSlides(index: number, v: string) {
    if (!v || !v.length) {
      return this.change('imageUrl', index, v, true);
    }
    return this.imageCache.url(Path.parse(v)).then(url => this.change('imageUrl', index, url, true));
  }

  public selectImage(index: number) {
    const modal = this.modal.open(MediaModalComponent, {
      backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'explorer-modal'
    });

    modal.componentInstance.mediaPath = this.path;

    return modal.result.then(async res => {
      if (!res || !res.length) {
        return;
      }

      const file = res[0];
      this.change('image', index, file.uuid);

      for (const [i, slide] of this.slides.entries()) {
        await this.heroSlides(i, slide.image);
      }
    });
  }

  public changeLinkDestionation(index: number, val: boolean) {
    if (this.slides[index].externalLink !== val) {
      this.change('externalLink', index, val);
      this.changeLink(index, '');
    }
  }

  public changeLink(index: number, val: string) {
    if (val.length === 0 || !val) {
      this.change('linkError', index, '');
      return this.change('link', index, val);
    }

    if (!this.slides[index].externalLink) {
      const node = this.tree.get(Path.parse(val));
      if (!node) {
        return this.change('linkError', index, 'Please paste the link to an existing CMS node!');
      }
      this.change('linkError', index, '');
    } else {
      if (!val.match(this.regex)) {
        return this.change('linkError', index, 'Please paste an external link!');
      }
      this.change('linkError', index, '');
    }

    return this.change('link', index, val);
  }

  public change(key: string, index: number, val: any, initCall = false) {
    const blacklist = ['imageUrl', 'linkError', 'newHeadline', 'newText', 'newLink'];

    this.slides[index][key] = val;

    if (!blacklist.includes(key) && !initCall) {
      this.updateSlides.emit(this.slides);
    }
  }

  public deleteSlide(index: number) {
    this.slides.splice(index, 1);
    return this.updateSlides.emit(this.slides);
  }

  public changePosition(index: number, direction: number) {
    const tmp = this.slides[index];
    this.slides[index] = this.slides[index + direction];
    this.slides[index + direction] = tmp;
    return this.updateSlides.emit(this.slides);
  }

  public anchor(index: number, anchor: string) {
    this.slides[index].imageAnchor = anchor;
    return this.updateSlides.emit(this.slides);
  }
}
